const wrapper = document.querySelectorAll('.panel-wrapper')
const moreWrapper = document.querySelectorAll('.panel-wrapper-more')

wrapper.forEach((element) => {
    const toggle = element.querySelectorAll('.panel-toggle')

    toggle.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault()
            const target = el.parentNode.querySelector('.panel')
            if (target.style.maxHeight) {
                target.style.maxHeight = null
                target.classList.remove('is-active')
                el.classList.remove('is-active')
            } else {
                const otherPanels = element.querySelectorAll('.panel.is-active')
                const otherToggle = element.querySelectorAll('.panel-toggle.is-active')
                otherPanels.forEach((panel) => {
                    panel.classList.remove('is-active')
                    panel.style.maxHeight = null
                })
                otherToggle.forEach((toggle) => {
                    toggle.classList.remove('is-active')
                })
                target.style.maxHeight = target.scrollHeight + 'px'
                target.classList.add('is-active')
                el.classList.add('is-active')
            }
        })
    })
})

moreWrapper.forEach((element) => {
    const toggle = element.querySelectorAll('.panel-toggle')

    toggle.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault()
            const target = el.parentNode.parentNode.nextElementSibling
            if (target.style.maxHeight) {
                target.style.maxHeight = null
                target.classList.remove('is-active')
                el.classList.remove('is-active')
            } else {
                target.style.maxHeight = target.scrollHeight + 'px'
                target.classList.add('is-active')
                el.classList.add('is-active')
            }
        })
    })
})
